type ApiErrorPayload = {
  message?: string;
  message_ES?: string;
};

type AxiosLikeError = {
  response?: {
    data?: {
      apierror?: ApiErrorPayload;
      message?: string;
      message_ES?: string;
    } | string;
  };
};

export function getApiErrorMessage(
  error: unknown,
  fallback?: string
): string | undefined {
  const axiosError = error as AxiosLikeError;
  const data = axiosError?.response?.data;

  if (typeof data === "string" && data.trim()) {
    return data;
  }

  if (data && typeof data === "object") {
    const apiError = data.apierror;
    const message =
      apiError?.message_ES ??
      apiError?.message ??
      data.message_ES ??
      data.message;
    if (message) {
      return message;
    }
  }

  return fallback;
}
